export const hoverTime = 2000;
export const SIDEBAR_WIDTH = 200;
export const COLLAPSED_SIDEBAR_WIDTH = 15.375;
export const HEADER_HEIGHT = 60;
export const FOOTER_HEIGHT = 83;

export const SOCIAL_SENTIMENT_DOMAINS = {
  GENERAL: 'general',
  REDDIT: 'reddit',
  STOCKTWITS: 'stocktwits',
};

export const searchSuggestionTypeConfig = {
  simpleSearchTextArray: 'simpleSearchTextArray',
  searchTextWithAnd: 'searchTextWithAnd',
  ignoreSearchTextArray: 'ignoreSearchTextArray',
};

export const highchartBaseConfig = {
  chart: {
    style: {
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    },
  },
};

export const SENTENCE_COLORS = {
  Positive: '#00ff00',
  Negative: '#ff0000',
  Neutral: '#808080',
};

export const SEPARATOR = '-ec-separator-';

export const SENTIMENT_PREFIX = {
  SENTIMENT: 'SENTIMENT',
  COMPUTEXT: 'COMPUTEXT',
};

export const USER_PLANS = {
  udt: 'UDT',
  udtSec: 'UDT Sec',
  udtSedar: 'UDT Sedar',
  udtGlobal: 'UDT Global',
  udtThemeX: 'UDT ThemeX',
  udtComputext: 'UDT-Computext',
  aiChatbox: 'ai_chatbox',
  noLicenseNeeded: 'NO LICENSE NEEDED',
};
